@if (serverErrorService.appError$ | async; as error) {
  <rotec-notification-v2 type="error">
    <div translate>Service currently not available.</div>
    <div translate>
      Please contact your IT department or the Schenck digital support if this problem persists.
    </div>
    @if (error.length) {
      <div>
        <div class="rc-mt-10">Additional Information for Support</div>
        <div>{{ error }}</div>
      </div>
    }
  </rotec-notification-v2>
} @else {
  <div class="control-buttons">
    <button rotec-button-active bullet icon="plus" (click)="openAddEditUserModal()">
      {{ 'Add User' | translate }}
    </button>
  </div>
  @if (!(loading$ | async)) {
    <rotec-default-grid-v2
      columnWidthMode="pixel"
      [height]="gridHeight"
      [columns]="gridColumns"
      [data]="state$ | async"
      [selectConfig]="{
        checkboxAlwaysVisible: false,
        checkboxToggleOnWholeRow: false,
        checkboxesEnabled: false,
      }"
      (stateChange)="reactToStateChange($event)"
      (columnsChange)="reactToColumnsChange($event)"
      (pageSizeChanged)="reactToPageSizeChange($event)"
      [noDataText]="noDataText"
      [filterButton]="false"
      [searchInput]="false"
      (rowClick)="onRowClick($event)"
    >
      <ng-template rotecGridCellV2="email" let-dataItem="dataItem">
        <p class="grid-text-cell text-bold">{{ dataItem.email }}</p>
      </ng-template>
      <ng-template rotecGridCellV2="givenName" let-dataItem="dataItem">
        <p class="grid-text-cell text-bold">{{ dataItem.givenName }}</p>
      </ng-template>
      <ng-template rotecGridCellV2="surname" let-dataItem="dataItem">
        <p class="grid-text-cell text-bold">{{ dataItem.surname }}</p>
      </ng-template>
      <ng-template rotecGridCellV2="role" let-dataItem="dataItem">
        <p class="grid-text-cell text-bold">{{ dataItem.role }}</p>
      </ng-template>
      <ng-template rotecGridCellV2="actions" let-dataItem="dataItem">
        @if (dataItem.role != 'RoTec') {
          <rotec-action-menu-v2
            [menuItems]="selectedMenuItems"
            (click)="setSelectedUser(dataItem, $event)"
            [menuIconColor]="selectedGridRowId == dataItem.id ? 'white' : 'gray'"
          ></rotec-action-menu-v2>
        }
      </ng-template>
    </rotec-default-grid-v2>
  } @else {
    <div [style.flex-direction]="'inherit'">
      <div class="spinner-snake"></div>
    </div>
  }
}
